import React, { PureComponent } from 'react';
import ReactAvatar from 'react-avatar';
import { injectIntl, intlShape } from 'react-intl';

import messages from './messages';
import ChatConversationHeaderUnread from '../../../modules/chat/conversation/ChatConversationHeaderUnread';

import { styles, getAvatarImageStyles, getAvatarWrapperStyles } from './styles';

export class Avatar extends PureComponent {
  renderUnread() {
    const { showUnread } = this.props;

    if (!showUnread) return null;

    return <ChatConversationHeaderUnread />;
  }

  renderDefaultOnly() {
    const { avatarColor, defaultName, size, intl } = this.props;
    const wrapperStyles = getAvatarWrapperStyles(size);
    return (
      <div
        style={wrapperStyles}
        className="kustomer-app-avatar"
        role="img"
        aria-label={intl.formatMessage(messages.aria_label_default_avatar)}
      >
        <ReactAvatar name={defaultName} style={styles.reactAvatar} color={avatarColor} size={size} round />
        {this.renderUnread()}
      </div>
    );
  }

  renderAvatarImage() {
    const { avatarUrl, size, intl } = this.props;
    const avatarStyles = getAvatarImageStyles(avatarUrl, size);
    const wrapperStyles = getAvatarWrapperStyles(size);

    return (
      <div style={wrapperStyles}>
        <div
          style={avatarStyles}
          className="kustomer-app-avatar"
          role="img"
          aria-label={intl.formatMessage(messages.aria_label_user_avatar)}
        />
        {this.renderUnread()}
      </div>
    );
  }

  renderAvatarImageWithDefaultBehind() {
    const { avatarUrl, avatarColor, defaultName, size, intl } = this.props;
    const avatarStyles = getAvatarImageStyles(avatarUrl, size);
    const wrapperStyles = getAvatarWrapperStyles(size);

    return (
      <div style={wrapperStyles}>
        <ReactAvatar name={defaultName} style={styles.reactAvatar} color={avatarColor} size={size} round />
        <div
          style={avatarStyles}
          className="kustomer-app-avatar"
          role="img"
          aria-label={intl.formatMessage(messages.aria_label_avatar)}
        />
        {this.renderUnread()}
      </div>
    );
  }

  render() {
    const { avatarUrl, includeDefault } = this.props;
    if (!avatarUrl && includeDefault) {
      return this.renderDefaultOnly();
    } else if (avatarUrl && includeDefault) {
      return this.renderAvatarImageWithDefaultBehind();
    }

    return this.renderAvatarImage();
  }
}

Avatar.propTypes = {
  avatarUrl: React.PropTypes.string,
  avatarColor: React.PropTypes.string,
  defaultName: React.PropTypes.string,
  size: React.PropTypes.number,
  includeDefault: React.PropTypes.bool,
  showUnread: React.PropTypes.bool,
  intl: intlShape.isRequired,
};

Avatar.defaultProps = {
  avatarUrl: null,
  avatarColor: null,
  defaultName: '',
  size: 30,
  includeDefault: true,
  showUnread: false,
};

export default injectIntl(Avatar);
